/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import React, { useState, useContext, useEffect, useRef } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import useSWR from 'swr';
import 'react-phone-number-input/style.css';
import PhoneInput from 'react-phone-number-input';
import { OTPInput } from 'Components/OTPInput';
import { encryptedKeyForCredentials } from 'Commons';
import { Pathname } from 'Routes';
import { Button } from 'Components';
import { AppContext, AuthContext } from 'Context';
import { AxiosCancelToken, dataFetcher, endpoints } from 'Api';
import { isMobile } from 'react-device-detect';
import { createRecaptchaVerifier, sendFirebaseOtp, mapFirebaseAuthError, phoneAuthSession } from 'Api/firebaseAuthClient';
import { AuthPage } from '../components/page';
import { Snackbar } from '../../../../Components/index';
import styles from './verificationCode.module.css';

export const NewVerifyCode = () => {
  const navigate = useNavigate();
  const {
    setAppSnackbar,
    userDetails,
    setUserDetails,
    plansPage,
    setPlansPage,
    langText,
    setReferralStatus,
  } = useContext(AppContext);
  const { forceAutoSignin, setToken, getToken, setEmailVerified } = useContext(AuthContext);
  const isDesktopApp = sessionStorage.getItem('isDesktopApp') === 'true';
  const mobileVerificationText = langText?.mobileVerification;
  const commonText = langText?.common;
  const signUpText = langText?.signInUp;
  const OTP_RESEND_TIME = 60;
  const [expireTime, setExpireTime] = useState(OTP_RESEND_TIME);
  const [OTP, setOTP] = useState({
    one: '',
    two: '',
    three: '',
    four: '',
    five: '',
    six: '',
  });
  const [otpFinal, setOtpFinal] = useState();
  // const [OTP, setOTP] = useState('');
  const email = sessionStorage.getItem(encryptedKeyForCredentials.email);
  // const mobile = sessionStorage.getItem(encryptedKeyForCredentials.mobile);
  const password = sessionStorage.getItem(encryptedKeyForCredentials.password);
  const [mobile, setMobile] = useState(
    sessionStorage.getItem(encryptedKeyForCredentials.mobile)
  );
  const [isOtpReached, setOtpReached] = useState(
    sessionStorage.getItem('#fs656gfhllh@#$')
  );
  const [first, setfirst] = useState(true);
  const [sendOtpCount, setSendOtpCount] = useState(0);
  const [pastedValue, setPastedValue] = useState('');
  const token = getToken();
  const firstInput = useRef();
  const secondInput = useRef();
  const thirdInput = useRef();
  const fourthInput = useRef();
  const fifthInput = useRef();
  const sixthInput = useRef();
  const re = /^[0-9\b]+$/;
  const [confirmingCode, setConfirmingCode] = useState(false);

  const { isValidating: signingInUser, mutate: signInUser } = useSWR([endpoints.signin, email, password], {
    fetcher: (url, inputEmail, inputPassword) => dataFetcher(url, { email: inputEmail, password: inputPassword }),
    onSuccess: ({ isNewUser, success, data, api_response, referral_status, is_skip, message, verify_mobile, mobile: userMobile }) => {
      if (success) {
        if (window.gtag) {
        window.gtag('event', 'sign_up', {
          method: 'email', // or 'google', etc., based on your signup method
          user_id: data?.id,
          email: data?.email,
          timestamp: new Date().toISOString(), // GA will treat this as a custom param
        });
      }

        // Handle desktop app callback - this is where signup/login actually completes
        if (isDesktopApp) {
          const isWindows = sessionStorage.getItem('isWindowsDesktop') === 'true';
          const callbackScheme = isWindows ? 'http://localhost:8080/callback' : 'projector-app://callback';
          const callbackUrl = `${callbackScheme}?${new URLSearchParams({
            token: api_response?.access || '',
            projector_token: data?.token || '',
            email: data?.email || email,
            isNewUser
          }).toString()}`;

          // Clean up session storage
          sessionStorage.removeItem('isDesktopApp');
          sessionStorage.removeItem('isWindowsDesktop');
          sessionStorage.removeItem(encryptedKeyForCredentials.email);
          sessionStorage.removeItem(encryptedKeyForCredentials.password);
          sessionStorage.removeItem(encryptedKeyForCredentials.mobile);

          window.location.href = callbackUrl;
          return;
        }

        sessionStorage.removeItem(encryptedKeyForCredentials.email);
        sessionStorage.removeItem(encryptedKeyForCredentials.password);
        sessionStorage.removeItem(encryptedKeyForCredentials.mobile);
        setUserDetails({ ...userDetails, isNewUser, mobile: userMobile });
        setMobile(userMobile);
        setToken(data?.token);
        setEmailVerified(data?.is_email_verified);
        // setAppSnackbar({ message: 'Logged in successfully', isVisible: true });
        forceAutoSignin();
        if ((parseInt(referral_status, 10) === 1 && parseInt(is_skip, 10) !== 1 && !data?.billing_date)) {
          setPlansPage(false);
          parseInt(referral_status, 10) === 1 && parseInt(is_skip, 10) !== 1 ? setReferralStatus(1) : setReferralStatus(0);
           navigate(Pathname.plans);
        } else if (parseInt(data?.verify_mobile, 10) === 0) {
          // has_logged_in === '0' ? navigate(Pathname.gettingStarted) : navigate(Pathname.access);
          navigate(Pathname.authentication.newmobileVerification);
        } else {
          // setAppSnackbar({
          //   message: message || 'Incorrect password',
          //   isVisible: true,
          // });
        }
      } else if (!verify_mobile) {
        if (userMobile) {
          //   navigate(Pathname.authentication.verifyCode);
          navigate(Pathname.authentication.newverifyCode);
        } else {
          navigate(Pathname.authentication.newmobileVerification);
        }
      } else {
        if (isDesktopApp) {
          const isWindows = sessionStorage.getItem('isWindowsDesktop') === 'true';
          const callbackScheme = isWindows ? 'http://localhost:8080/callback' : 'projector-app://callback';
          window.location.href = `${callbackScheme}?error=${encodeURIComponent(message || 'Verification failed')}`;
          return;
        }
        setAppSnackbar({ message: message || 'Incorrect password', isVisible: true });
      }
      navigate(Pathname.authentication.avatar, { state: { fromVerificationCode: true } });
    },
    onError: (error) => {
      if (isDesktopApp) {
        const isWindows = sessionStorage.getItem('isWindowsDesktop') === 'true';
        const callbackScheme = isWindows ? 'http://localhost:8080/callback' : 'projector-app://callback';
        window.location.href = `${callbackScheme}?error=${encodeURIComponent(error?.response?.data?.message || 'Authentication failed')}`;
        return;
      }
      const responseData = error?.response?.data;
      // if ('email_verified' in responseData && !responseData?.email_verified) {
      //   sessionStorage.setItem('emailForValidation_projectoruser', email);
      //   navigate(Pathname.authentication.verifyEmail);
      // } else {
      setAppSnackbar({ message: responseData?.message || 'Oops! Something went wrong', isVisible: true });
      setConfirmingCode(false);
      // }
    },
  });
  // Shared "code accepted" action — signs the user in (which sets the token and
  // lands on the avatar page) or, with no email, goes straight to avatar.
  const proceedAfterOtp = () => {
    if (email) {
      signInUser();
    } else {
      navigate(Pathname.authentication.avatar, { state: { fromVerificationCode: true } });
    }
  };

  const defaultSnackbar = { isVisible: false, message: '', type: 'default' };
  const [snackbarData, setSnackbar] = useState(defaultSnackbar);
  const resendRecaptchaVerifierRef = useRef(null);
  const idTokenRef = useRef();
  const [sendingOtp, setSendingOtp] = useState(false);

  const { isValidating: verifyingToken, mutate: verifyFirebaseToken } = useSWR([endpoints.verifyOtpFirebase, email], {
    fetcher: (url, email) => dataFetcher(url, { email, firebaseToken: idTokenRef.current }),
    onSuccess: ({ success, message }) => {
      if (success) {
        proceedAfterOtp();
      } else if (isDesktopApp) {
        const isWindows = sessionStorage.getItem('isWindowsDesktop') === 'true';
        const callbackScheme = isWindows ? 'http://localhost:8080/callback' : 'projector-app://callback';
        window.location.href = `${callbackScheme}?error=${encodeURIComponent(message || 'OTP verification failed')}`;
      } else {
        setAppSnackbar({ message: message || 'Oops! Something went wrong', isVisible: true });
        setConfirmingCode(false);
      }
    },
    onError: (error) => {
      if (isDesktopApp) {
        const isWindows = sessionStorage.getItem('isWindowsDesktop') === 'true';
        const callbackScheme = isWindows ? 'http://localhost:8080/callback' : 'projector-app://callback';
        window.location.href = `${callbackScheme}?error=${encodeURIComponent(error?.response?.data?.message || 'OTP verification failed')}`;
      } else {
        const responseData = error?.response?.data;
        setSnackbar({ isVisible: true, message: responseData?.message, type: 'error' });
        setAppSnackbar({ message: responseData?.message || 'Oops! Something went wrong', isVisible: true });
        setConfirmingCode(false);
      }
    },
  });
  const verifyingOTP = confirmingCode || verifyingToken || signingInUser;

  // Stays `true` from the moment the user submits until either the flow fails
  // (each failure path re-enables the button so the code can be retried) or we
  // navigate away — this avoids a gap between the Firebase confirm resolving
  // and the backend calls starting, where the button would briefly re-enable.
  const verifyOtp = async () => {
    setConfirmingCode(true);
    try {
      const result = await phoneAuthSession.confirmationResult.confirm(otpFinal);
      idTokenRef.current = await result.user.getIdToken();
      verifyFirebaseToken();
    } catch (error) {
      setAppSnackbar({ message: mapFirebaseAuthError(error), isVisible: true });
      setConfirmingCode(false);
    }
  };

  const getResendRecaptchaVerifier = () => {
    if (!resendRecaptchaVerifierRef.current) {
      resendRecaptchaVerifierRef.current = createRecaptchaVerifier('firebase-recaptcha-container-resend');
    }
    return resendRecaptchaVerifierRef.current;
  };

  const requestVerificationCode = async () => {
    setSendingOtp(true);
    try {
      const verifier = getResendRecaptchaVerifier();
      await sendFirebaseOtp(mobile, verifier);
      setOtpReached(true);
      setSendOtpCount(1);
      setAppSnackbar({ message: 'Code send to mobile number', isVisible: true });
    } catch (error) {
      setAppSnackbar({ message: mapFirebaseAuthError(error), isVisible: true });
      resendRecaptchaVerifierRef.current = null;
    } finally {
      setSendingOtp(false);
    }
  };

  useEffect(() => {
    if (isOtpReached) {
      if (!expireTime) return;
      const intervalId = setInterval(() => {
        setExpireTime(expireTime - 1);
      }, 1000);
      // clear interval on re-render to avoid memory leaks
      return () => clearInterval(intervalId);
    }
  }, [expireTime, isOtpReached]);

  useEffect(() => {
    if (!sendOtpCount && !isOtpReached) {
      // requestVerificationCode();
    } else {
      setOtpReached(true);
      sessionStorage.removeItem('#fs656gfhllh@#$');
    }
  }, [sendOtpCount, isOtpReached]);

  useEffect(() => {
    setOtpFinal(`${OTP.one}${OTP.two}${OTP.three}${OTP.four}${OTP.five}${OTP.six}`);
  }, [OTP]);

  /** Change state of input according to pasted data */
  useEffect(() => {
    if (pastedValue.length === 6) {
      setOTP({
        one: pastedValue[0],
        two: pastedValue[1],
        three: pastedValue[2],
        four: pastedValue[3],
        five: pastedValue[4],
        six: pastedValue[5],
      });
      setPastedValue('');
      sixthInput?.current.focus();
    }
  }, [pastedValue]);

  const resendCodeHandler = () => {
    setExpireTime(OTP_RESEND_TIME);
    setSendOtpCount(0);
    requestVerificationCode();
  };

  function handleOtpInput(value, otpInputPos, nextInput, prevInput) {
    if (value && value !== '' && nextInput) {
      nextInput?.current.focus();
    } else if ((!value || value === '') && prevInput) {
      prevInput?.current.focus();
    }
    if (value?.length <= 1) {
      setOTP({ ...OTP, [otpInputPos]: value });
    }
  }

  const handlePaste = (event) => {
    event.preventDefault();
    const paste = event.clipboardData.getData('text');
    if (paste.length <= 6) {
      setPastedValue(paste);
    }
  };

  const handleCancel = () => {
    if (isDesktopApp) {
      const isWindows = sessionStorage.getItem('isWindowsDesktop') === 'true';
      const callbackScheme = isWindows ? 'http://localhost:8080/callback' : 'projector-app://callback';
      window.location.href = `${callbackScheme}?error=cancelled`;
    } else {
      navigate(-1);
    }
  };

  return (
    <>
      <div>
        <AuthPage>
          {
            !isMobile && <div aria-hidden="true" onClick={() => { navigate(-1); }} className={styles.backLink}>BACK</div>
          }
          {
            isDesktopApp && <div style={{ marginTop: '50px' }} aria-hidden="true" onClick={handleCancel} className={styles.backLink}>Cancel</div>
          }
          {isOtpReached ? (
            <form
              onPaste={handlePaste}
              className={styles.alignForm}
              onSubmit={(e) => {
                e.preventDefault();
                verifyOtp();
              }}
            >
              <div className={styles.inputLabel}>
                {mobileVerificationText?.enterYourCode || 'Enter your code'}
              </div>
              <div className={styles.description}>
                <div>
                  A code was send to your number, please check and enter below.
                </div>
                <div>
                  If you do not see the code please try to resend in &nbsp;
                  <span style={{ color: 'white' }}>{`${expireTime}s`}</span>
                </div>
              </div>
              {/* <span style={{ textAlign: 'center' }} className={styles.description}>{`A code was send to your number ${mobile || userDetails?.mobile}, please check and enter below. If you do not see the code please try to resend in `}</span>
                <span className={styles.expireTime}>{`${expireTime}s`}</span> */}
              <br />
              <div className={styles.buttonBlock}>
                <div style={{ paddingLeft: '8px', display: 'flex' }}>
                  <div style={{ paddingRight: '18px' }}>
                    <input
                      type="number"
                      max={9}
                      value={OTP.one}
                      ref={firstInput}
                      onChange={(event) => handleOtpInput(event.target.value, 'one', secondInput)}
                      className={styles.codeInput}
                    />
                  </div>
                  <div style={{ paddingRight: '18px' }}>
                    <input
                      type="number"
                      max={9}
                      value={OTP.two}
                      ref={secondInput}
                      onChange={(event) => handleOtpInput(
                          event.target.value,
                          'two',
                          thirdInput,
                          firstInput
                        )}
                      className={styles.codeInput}
                    />
                  </div>
                  <div style={{ paddingRight: '18px' }}>
                    <input
                      type="number"
                      max={9}
                      value={OTP.three}
                      ref={thirdInput}
                      onChange={(event) => handleOtpInput(
                          event.target.value,
                          'three',
                          fourthInput,
                          secondInput
                        )}
                      className={styles.codeInput}
                    />
                  </div>
                  <div style={{ paddingRight: '18px' }}>
                    <input
                      type="number"
                      max={9}
                      value={OTP.four}
                      ref={fourthInput}
                      onChange={(event) => handleOtpInput(
                          event.target.value,
                          'four',
                          fifthInput,
                          thirdInput
                        )}
                      className={styles.codeInput}
                    />
                  </div>
                  <div style={{ paddingRight: '18px' }}>
                    <input
                      type="number"
                      max={9}
                      value={OTP.five}
                      ref={fifthInput}
                      onChange={(event) => handleOtpInput(
                          event.target.value,
                          'five',
                          sixthInput,
                          fourthInput
                        )}
                      className={styles.codeInput}
                    />
                  </div>
                  <div style={{ paddingRight: '18px' }}>
                    <input
                      type="number"
                      max={9}
                      value={OTP.six}
                      ref={sixthInput}
                      onChange={(event) => handleOtpInput(
                          event.target.value,
                          'six',
                          null,
                          fifthInput
                        )}
                      className={styles.codeInput}
                    />
                  </div>
                </div>
                {/* <input
                    type="tel"
                    maxLength={5}
                    value={OTP}
                    onChange={handleChange}
                    style={{ width: '200px', height: '55px', borderRadius: '10px', backgroundColor: '#31343e', border: '2px solid #6d6f76', color: '#ffffff', fontSize: '20px', fontWeight: '700', textAlign: 'center' }}
                  /> */}
                {/* <OTPInput className={styles.otpInputs} inputStyles={{ width: '60px', height: '55px', borderRadius: '10px', backgroundColor: '#31343e', border: '2px solid #6d6f76', color: '#ffffff', fontSize: '20px', fontWeight: '700' }} value={OTP} onChange={setOTP} autoFocus OTPLength={5} otpType="number" disabled={false} /> */}
              </div>
              <br />
              <div className={styles.buttonBlock}>
                <Button
                  isFullWidth
                  blockText
                  isDisabled={
                    !otpFinal || otpFinal?.length !== 6 || verifyingOTP
                  }
                  isBlue
                  isLarge
                  submit
                >
                  {mobileVerificationText?.continue || 'Continue'}
                </Button>
              </div>
            </form>
          ) : null}
          <div
            className={styles.resendDiv}
            // onClick={() => { setExpireTime(120); setSendOtpCount(0); }}
          >
            <button
              style={{ borderStyle: 'none', marginTop: '-0px' }}
              onClick={() => {
                resendCodeHandler();
              }}
              disabled={expireTime !== 0 || sendingOtp}
            >
              {mobileVerificationText?.resendLink || 'Resend Code'}
            </button>
          </div>
          <Snackbar
            {...snackbarData}
            onClose={() => {
              setSnackbar({ ...snackbarData, isVisible: false });
            }}
          />
          <div id="firebase-recaptcha-container-resend" />
        </AuthPage>
      </div>
    </>
  );
};
